import { Controller } from "@hotwired/stimulus";

// Ensures the inbox is reloaded with the current read/unread status after a browser back.
export default class extends Controller {
  connect() {
    const navEntries = performance.getEntriesByType("navigation");
    const nav = navEntries[0];

    if (nav && nav.type === "back_forward") {
      window.Turbo?.visit(window.location.href, { action: "replace" });
    }
  }
}

